"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var HistoryIcon_1 = __importDefault(require("../widgets/HistoryIcon"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        rootDiv: {
            display: 'block',
            textAlign: 'right',
        },
        linkButton: {
            padding: 0,
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
    });
});
function LinkHistoryButton(_a) {
    var clickHandler = _a.clickHandler;
    var classes = useStyles();
    var theme = core_1.useTheme();
    return (react_1.default.createElement("div", { className: classes.rootDiv },
        react_1.default.createElement(core_1.Button, { className: classes.linkButton, onClick: clickHandler, size: "large", variant: "text" },
            react_1.default.createElement(core_1.Typography, { variant: "body2", color: "primary" }, "View Link History"),
            react_1.default.createElement(HistoryIcon_1.default, { color: theme.palette.primary.main }))));
}
exports.default = LinkHistoryButton;
